import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'checklist',
  template: require('./checklist.component.html'),
  styles: [require('./checklist.component.scss')]
})
export class ChecklistComponent {
  @Input() list: string[];
  @Output() onSelect: EventEmitter<string[]> = new EventEmitter<string[]>();

  private checkedItems: string[] = [];

  onSelectItem(selectedItem: string): void {
    const itemIsChecked: boolean = !!this.checkedItems.find((checkedItem: string): boolean => checkedItem === selectedItem);

    if (!itemIsChecked) {
      this.checkedItems = [
        ...this.checkedItems,
        selectedItem,
      ];
    }

    if (itemIsChecked) {
      this.checkedItems = this.checkedItems.filter((checkedItem) => checkedItem !== selectedItem);
    }

    this.onSelect.emit(this.checkedItems);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/checklist/checklist.component.ts